const handleAlwaysAvailableScheduled = () => {
  // Always available tickets are never scheduled - they're either on sale or not based on other conditions
  return { isScheduled: false, hasInvalidReference: false };
};

export default handleAlwaysAvailableScheduled;